import React from 'react';

const sessionStorageContext = React.createContext(null);

export default sessionStorageContext;
